import { Button, Col, Input, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { authFeatureConstants, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { ReactComponent as Refresh } from '../../../assets/images/svg/Refresh.svg';
import { SearchOutlined } from '@ant-design/icons';
import List from './List';
import NewConcentModal from './NewConcentModal';
import { useDispatch } from 'react-redux';
import { applyFilters, reloadHIUList } from '../../../store/actions/abdmHiuAction';
import { canActivate } from '../../../utils/utility';

const ConcentList = (): ReactElement => {
  const [isNew, setIsNew] = useState<boolean>(false);
  const dispatch = useDispatch();

  const onNewConcentCancel = (): any => {
    setIsNew(false);
  };

  const onSearch = (ev: any): any => {
    dispatch(applyFilters({abhaAddress: ev?.target?.value}));
  };

  return (
    <React.Fragment>
      <PageHeader
        pageTitle="Consent List"
        backUrl="/abdm"
        rightComponent={(): any => (
        <Row gutter={GUTTOR_SPACE} justify="end" className="rightComponent mr-10">
          <Col md={8}>
            <Input
              onChange={onSearch}
              className="input-search"
              placeholder="Search by ABHA address"
              suffix={<SearchOutlined />}
            />
          </Col>
          {
            canActivate(authFeatureConstants.EDIT_ABDM_HIU) &&
            <Col md={6}>
              <Button type="primary" onClick={(): any => setIsNew(true)}>New Consent Request</Button>
            </Col>
          }
          <Col md={1} className = "mt-3" onClick={(): any => dispatch(reloadHIUList())}>
            <Refresh />
          </Col>
        </Row>
        )}
      />
      <List />
      {isNew && <NewConcentModal visible={isNew} onClose={onNewConcentCancel} />}
    </React.Fragment>
  );
};

export default ConcentList;
